import { OvstErrorCode } from "../enums/ovst-error-codes";
import { IHttpError } from "../interfaces/http-errror";

// A 401 with OVST_CONS_0003 is a scope refusal: the caller stays signed in. Any other 401
// means the session is over or the account was disabled.
export const isScopeRefusal = (error?: Partial<IHttpError>) =>
  error?.status === 401 &&
  error.ovstErrorCode === OvstErrorCode.OVST_CONS_0003;
